import React, {useState} from 'react'
import './TabbedMenuBox.css';
import {Zoom} from 'react-awesome-reveal';
import './pages/FAQs.css';

const TabbedMenuBox = ({tabData}) => {

    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (index) => {
        setActiveTab(index);
    };

    return (
        <Zoom className='zoom-container' triggerOnce={true}>
            <div className="tabsContainer">
            <div className="tabs">
                {tabData.map((tab, index) => (
                    <h3
                        key={index}
                        className={`tab ${index === activeTab ? 'active' : ''}`}
                        onClick={() => handleTabClick(index)}
                    >
                        {tab.heading}
                    </h3>
                ))}
            </div>
            <div className="tabContent">
                {tabData[activeTab].content}
            </div>
            </div>
        </Zoom>
    );
}

export default TabbedMenuBox